import {AppState} from "../AppState"

export interface ApiAuthRequestInterface {
    auth_token: string
    Agent: 'Chrome'
    IsMarketPlace: 'true'
    api_version :'1.0'
}

export function BuildAuthRequestFromAppState(state?: AppState): ApiAuthRequestInterface {
    return {
        api_version: '1.0',
        Agent: 'Chrome',
        IsMarketPlace: 'true',
        auth_token: state?.Workforce1State.webToken || "",
    }
}
